<template>
  <div id="app" class="mt-16">
    <v-container class="px-0" fluid>
      <v-row no-gutters>
        <v-col cols="12">
          <div>
            <!-- <h3 class="title px-4">{{ $t('alquilar_ahora') }}</h3> -->
            <!-- Rent a Car Plugin -->
            <radaReserva/>
          </div>
        </v-col>
        <!-- <v-col cols="12" class="pt-0" align="center">
          <v-container class="pt-0">
            <v-row no-gutters>
              <CardCars/>
            </v-row>
          </v-container>
        </v-col> -->
      </v-row>
    </v-container>
  </div>
</template>

<script>
import radaReserva from './rada-horizontal'
import CardCars from '../components/CardCars.vue';

export default {
  name: 'Home',
  components: {
    radaReserva,
    CardCars
  },
   data: () => ({
    numPage: 4,
  }),
};
</script>

<style scoped>
.card-content {
  flex-direction: column;
  justify-content: start;
}

.image-contain img {
  object-fit: cover;
  width: 250px;
  height: 150px;
  margin-bottom: 0;
}

.no-margin {
  margin-top: 0;
  padding-top: 0;
}
</style>
